module.exports = __webpack_public_path__ + "static/media/cart-light.fceb8832.svg";